<template>
  <vs-row align="center" justify="center">
    <vs-col>
      <vs-col v-if="logo_url">
        <img class="logo" :src="logo_url"/>
      </vs-col>
      <h1 id="h1-components-thankyou-textthankyou">Thank You</h1>
      <p>An email confirmation has been sent to {{ email }}</p>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    logo:{
      type:String,
      require:false
    },
    logo_url:{
      type:String,
      require:false
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: #83bc00;
  font-size: 100px;
  font-weight: 700;
  margin: 1rem 0;
  text-transform: uppercase;
}

h3 {
  font-size: 48px;
  font-weight: 700;
  margin: 1rem 0;
}

p {
  font-size: 1.2rem;
  font-weight: 400;
}
.logo{
  max-width: 200px;
}

@media (max-width: 768px) {
    h1{
      font-size: 30px;
    }
    h2{
      font-size: 26px;
    }
    h3{
      font-size: 18px;
    }
}

img {
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 90%;
  }
}
</style>
